module.exports = __webpack_public_path__ + "static/media/NN Logo Final-04.02b02678.jpg";